export default "__VITE_ASSET__Cy_lSls___"